export const DEMAND_CATEGORY_CREATE_REQUEST = 'DEMAND_CATEGORY_CREATE_REQUEST';
export const DEMAND_CATEGORY_CREATE_SUCCESS = 'DEMAND_CATEGORY_CREATE_SUCCESS';
export const DEMAND_CATEGORY_CREATE_FAIL = 'DEMAND_CATEGORY_CREATE_FAIL';

export const DEMAND_CATEGORY_DETAILS_REQUEST = 'DEMAND_CATEGORY_DETAILS_REQUEST';
export const DEMAND_CATEGORY_DETAILS_SUCCESS = 'DEMAND_CATEGORY_DETAILS_SUCCESS';
export const DEMAND_CATEGORY_DETAILS_FAIL = 'DEMAND_CATEGORY_DETAILS_FAIL';
export const DEMAND_CATEGORY_DETAILS_RESET = 'DEMAND_CATEGORY_DETAILS_RESET';


export const DEMAND_CATEGORY_DETAILS_REVENUE_REQUEST = 'DEMAND_CATEGORY_DETAILS_REVENUE_REQUEST';
export const DEMAND_CATEGORY_DETAILS_REVENUE_SUCCESS = 'DEMAND_CATEGORY_DETAILS_REVENUE_SUCCESS';
export const DEMAND_CATEGORY_DETAILS_REVENUE_FAIL = 'DEMAND_CATEGORY_DETAILS_REVENUE_FAIL';
export const DEMAND_CATEGORY_DETAILS_REVENUE_RESET = 'DEMAND_CATEGORY_DETAILS_REVENUE_RESET';

export const CATEGORY_TEMPLATES_REQUEST = 'CATEGORY_TEMPLATES_REQUEST';
export const CATEGORY_TEMPLATES_SUCCESS = 'CATEGORY_TEMPLATES_SUCCESS';
export const CATEGORY_TEMPLATES_FAIL = 'CATEGORY_TEMPLATES_FAIL';

// NEW: Fetch category names for autocomplete (includes existing categories for LGA)
export const CATEGORY_NAMES_FOR_LGA_REQUEST = 'CATEGORY_NAMES_FOR_LGA_REQUEST';
export const CATEGORY_NAMES_FOR_LGA_SUCCESS = 'CATEGORY_NAMES_FOR_LGA_SUCCESS';
export const CATEGORY_NAMES_FOR_LGA_FAIL = 'CATEGORY_NAMES_FOR_LGA_FAIL';

export const CATEGORY_NAME_VALIDATE_REQUEST = 'CATEGORY_NAME_VALIDATE_REQUEST';
export const CATEGORY_NAME_VALIDATE_SUCCESS = 'CATEGORY_NAME_VALIDATE_SUCCESS';
export const CATEGORY_NAME_VALIDATE_FAIL = 'CATEGORY_NAME_VALIDATE_FAIL';

export const DEMAND_CATEGORY_UPDATE_REQUEST = 'DEMAND_CATEGORY_UPDATE_REQUEST';
export const DEMAND_CATEGORY_UPDATE_SUCCESS = 'DEMAND_CATEGORY_UPDATE_SUCCESS';
export const DEMAND_CATEGORY_UPDATE_FAIL = 'DEMAND_CATEGORY_UPDATE_FAIL';
export const DEMAND_CATEGORY_UPDATE_RESET = 'DEMAND_CATEGORY_UPDATE_RESET';